/// <amd-module name="Feed/Legacy/Protocols/Ivy/Constants/IvyConstants" />
import { PerfScenarios } from "Feed/Common/Constants/Constants";

export class IvyPerfScenarios extends PerfScenarios {
    public static PromotePackage = "Packaging.Package.Ivy.PromotePackage";
    public static DeletePackage = "Packaging.Package.Ivy.DeletePackage";
}

export class IvyCiConstants {
    public static LicenseLinkClicked = "LicenseLinkClicked";
    public static OrganizationLinkClicked = "OrganizationLinkClicked";
    public static IvyDevelopment = "IvyDevelopment";
    public static ProtocolName = "Ivy";
    public static IvyConnectToFeedPanel = "IvyConnectToFeedPanel";
    public static ModuleIndexAnchorClicked = "ModuleIndexAnchorClicked";
    public static DeletePackage = "DeletePackage";
    public static Publications = "Publications";
    public static PublicationAnchorClicked = "PublicationAnchorClicked";
}

export class IvyExternalLinks {
    public static CredentialsReference = "https://go.microsoft.com/fwlink/?linkid=856392";
    public static SettingsReference = "https://go.microsoft.com/fwlink/?linkid=856394";
    public static UrlResolverReference = "https://go.microsoft.com/fwlink/?linkid=856395";
}
